import React from 'react'

export default function CompanyResearch() {
  return (
    <div>CompanyResearch</div>
  )
}
